import { render, staticRenderFns } from "./AsideItem.vue?vue&type=template&id=18ef7d3b&scoped=true&"
import script from "./AsideItem.vue?vue&type=script&lang=ts&"
export * from "./AsideItem.vue?vue&type=script&lang=ts&"
import style0 from "./AsideItem.vue?vue&type=style&index=0&id=18ef7d3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef7d3b",
  null
  
)

export default component.exports